/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useMemo, useState } from "react";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "~/db/db";

const useServico = ({ microrregiaoId = 0 }) => {
  const [familias, setFamilias] = useState([]);
  const [filiais, setFiliais] = useState([]);

  const [servicos, setServicos] = useState([]);

  const fetchServicosByFilter = async (filter) => {
    const result = [];
    await filter.each((item) => {
      result.push({
        filialId: item.filialId,
        denominacao: item.denominacao,
        porcentagem: Number(item.porcentagemCondicao ?? "0"),
        familiaId: item.familiaId,
        microrregiaoId: item.microrregiaoId,
      });
    });
    return result;
  };

  useEffect(() => {
    const fetchServicos = async () => {
      let filter = db.servico;
      let wheres = 0;

      if (microrregiaoId) {
        filter = filter.where('microrregiaoId').equals(microrregiaoId);
        wheres++;
      }

      if (familias.length > 0) {
        if (wheres < 1) {
          filter = filter.where('familiaId').anyOf(familias);
          wheres++;
        }
        else
          filter.and(servico => familias.includes(servico.familiaId));
      }

      if (filiais.length > 0) {
        if (wheres < 1)
          filter = filter.where('filialId').anyOf(filiais);
        else
          filter.and(servico => filiais.includes(servico.filialId));
      }

      if (microrregiaoId || familias.length > 0 || filiais.length > 0) {
        const result = await fetchServicosByFilter(filter);
        setServicos(result);
      }
    };

    fetchServicos();
  }, [microrregiaoId, filiais, familias]);


  return {
    servicos,
    setFamilias,
    setFiliais
  };
}

export default useServico;